import React from 'react'
import Person from '../bills/Person'
import Table from '../elements/Table'
import * as personalizerStyles from '../../styles/project-modules/personalize/personalizer.module.less'
import chamberNames from '../../data/sfc/chamber_names.json'


function Result({ yourLegislators, MARKET_KEY }) {
  // console.log(yourLegislators)
  // const { data: responseData, error } = useSWR(
  //   `https://files.sfchronicle.com/test-feeds/legistracker/contacts/legis-contacts-${MARKET_KEY}.json`,
  //   getData,
  //   {
  //     onSuccess: (data) => {
  //       //format data for our table

  const tableData = yourLegislators.map((contactInfo) => {
    //         let contactInfo = datcaa[ocd_id]

  const { sldu: secondChamber, sldl: firstChamber} = chamberNames[MARKET_KEY]


    return {
      Lawmaker: (
        <Person
          name={contactInfo['name']}
          // img={contactInfo['photo_url']}
          party={contactInfo['party_id']}
          MARKET_KEY={MARKET_KEY}
        />
      ),
      District: contactInfo['district'] ? contactInfo['district'] : null,
    }
  })

  // setPeople(tableData)
  //     },
  //     onError: (err) => console.log(err),
  //   }
  // )

  return (
    <div>
      <h4 className={personalizerStyles.subhed}>Your legislators</h4>
      <Table data={tableData} useKeys={['District', 'Lawmaker']} />
    </div>
  )
}

export default Result
